<template>
  <h1 class="l-header-logo">
    <a class="l-header-logo__link" :href="headerData.topUrl">
      <header-logo-image />
    </a>
  </h1>
</template>

<script>
export default {
  props: {
    headerData: Object,
  }
};
</script>
